import * as joda from "@js-joda/core";
import { internalteacherid } from "../../../sql/classy/types";
import { isEqual } from "../../lib/isequal";

export function isSameSlot(
  a: {
    weekday: joda.DayOfWeek;
    time: joda.LocalTime;
    internalteacherid: internalteacherid;
  },
  b: {
    weekday: joda.DayOfWeek;
    time: joda.LocalTime;
    internalteacherid: internalteacherid;
  },
): boolean {
  return (
    isEqual(a.weekday, b.weekday) &&
    isEqual(a.time, b.time) &&
    a.internalteacherid === b.internalteacherid
  );
}
